<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col sm="6">
        <div class="form-group">
          <label
                  for="exsbbatchnumber_name"
                  class="form-control-label">{{$t('views.exsbbatchnumber.form.name')}}:</label>
          <input
                  id="exsbbatchnumber_name"
                  v-model="item.name"
                  :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('name', $event.target.value)">
          <div
                  v-if="isInvalid('name')"
                  class="invalid-feedback">{{ violations.name }}</div>
        </div>
      </b-col>
      <b-col sm="6">
        <div :class="['form-group', isInvalid('periodType') ? 'has-danger' : '']">
          <label
                  for="exsbbatchnumber_periodType"
                  class="form-control-label">{{$t('views.exsbbatchnumber.form.periodType')}}:</label>
          <fg-input :error="violations.periodType">
            <el-select
                    id="exsbbatchnumber_periodType"
                    :class="['select-default', isInvalid('periodType') ? 'select-danger' : '']"
                    :placeholder="$t('views.exsbbatchnumber.form.periodType')"
                    filterable
                    v-model="item.periodType">
              <el-option v-for="option in periodTypes"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div v-if="isInvalid('periodType')" class="invalid-feedback">{{ violations.periodType }}:</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <p class="mb-1">{{$t('views.exsbbatchnumber.form.instruction.lineOne')}}</p>
        <p class="mb-1">{{$t('views.exsbbatchnumber.form.instruction.lineTwo')}}</p>
        <p class="mb-1">{{$t('views.exsbbatchnumber.form.instruction.lineThree')}}</p>
        <p class="mb-1">{{$t('views.exsbbatchnumber.form.instruction.lineFour')}}</p>
        <ul class="mb-1">
          <li>{{$t('views.exsbbatchnumber.form.instruction.firstMenu.firstPosition')}}</li>
          <li>{{$t('views.exsbbatchnumber.form.instruction.firstMenu.secondPosition')}}</li>
          <li>{{$t('views.exsbbatchnumber.form.instruction.firstMenu.thirdPosition')}}</li>
          <li>{{$t('views.exsbbatchnumber.form.instruction.firstMenu.fourthPosition')}}</li>
        </ul>
        <p class="mb-1">{{$t('views.exsbbatchnumber.form.instruction.lineFifth')}}</p>
        <ul>
          <li>{{$t('views.exsbbatchnumber.form.instruction.secondMenu.firstPosition')}}</li>
          <li>{{$t('views.exsbbatchnumber.form.instruction.secondMenu.secondPosition')}}</li>
          <li>{{$t('views.exsbbatchnumber.form.instruction.secondMenu.thirdPosition')}}</li>
          <li>{{$t('views.exsbbatchnumber.form.instruction.secondMenu.fourthPosition')}}</li>
          <li>{{$t('views.exsbbatchnumber.form.instruction.secondMenu.fifthPosition')}}</li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6">
        <div class="form-group">
          <label
                  for="exsbbatchnumber_pattern"
                  class="form-control-label">{{$t('views.exsbbatchnumber.form.pattern')}}</label>
          <input
                  id="exsbbatchnumber_pattern"
                  v-model="item.pattern"
                  :class="['form-control', isInvalid('pattern') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('pattern', $event.target.value)">
          <div
                  v-if="isInvalid('pattern')"
                  class="invalid-feedback">{{ violations.pattern }}</div>
        </div>
      </b-col>
      <b-col sm="6">
        <div class="form-group">
          <label
                  for="exsbbatchnumber_firstNumber"
                  class="form-control-label">{{$t('views.exsbbatchnumber.form.firstNumber')}}:</label>
          <input
                  id="exsbbatchnumber_firstNumber"
                  v-model="item.firstNumber"
                  :class="['form-control', isInvalid('firstNumbewar') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('firstNumber', $event.target.value)">
          <div
                  v-if="isInvalid('firstNumber')"
                  class="invalid-feedback">{{ violations.firstNumber }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-radio-group
                  v-model="item.numerationType"
                  :options="numerationTypeOptions"
                  buttons
                  button-variant="outline-primary"
                  name="radios-btn-default"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="item.numerationType == 1">
      <b-col>
        <div class="form-group">
          <label
                  for="exsbbatchnumber_documentsAllowed"
                  class="form-control-label">{{$t('views.exsbbatchnumber.form.documentsAllowed')}}:</label>
          <b-form-group>
            <b-form-checkbox-group
                    v-model="item.documentsAllowed"
                    :options="documentTypes"
                    name="exsbbatchnumber_documentsAllowed"
            ></b-form-checkbox-group>
            <b-form-checkbox
              v-model="item.agreementsAllowed"
              :value="1"
              :unchecked-value="0"
            >{{$t('views.exsbbatchnumber.form.agreementsAllowed')}}</b-form-checkbox>
          </b-form-group>
          <div
                  v-if="isInvalid('documentsAllowed')"
                  class="invalid-feedback">{{ violations.documentsAllowed }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row v-else-if="item.numerationType == 2">
      <b-col>
        <div class="form-group">
          <label
                  for="exsbbatchnumber_documentsAllowed"
                  class="form-control-label">{{$t('views.exsbbatchnumber.form.documentsAllowed')}}:</label>
          <b-form-group>
            <b-form-checkbox-group
                    v-model="item.documentsAllowed"
                    :options="invoiceTypes"
                    name="exsbbatchnumber_documentsAllowed"
            ></b-form-checkbox-group>
          </b-form-group>
          <div
                  v-if="isInvalid('documentsAllowed')"
                  class="invalid-feedback">{{ violations.documentsAllowed }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-primary">{{$t('buttons.submit')}}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    item: function (itemUpdate) {
      itemUpdate.periodType = itemUpdate.periodType['@id']
    }
    // 'item.numerationType': function (val) {
    //   this.item.documentsAllowed = []
    // }
  },

  data () {
    return {
      periodTypes: [],
      invoiceTypes: [],
      documentTypes: [],
      numerationTypeOptions: [
        {
          value: 1,
          text: this.$t('views.exsbbatchnumber.form.documentsAllowedDocuments')
        },
        {
          value: 2,
          text: this.$t('views.exsbbatchnumber.form.documentsAllowedInvoices')
        },
        {
          value: 3,
          text: this.$t('views.exsbbatchnumber.form.documentsAllowedCases')
        }
      ]
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    this.getPeriodTypes()
    this.getInvoiceTypes()
    this.getDocumentTypes()
    this.createContractorUserDataWatcher()
  },

  methods: {
    createNumerationTypeWatcher () {
      this.unwatchNumerationTypeWatcher = this.$watch(
        function () {
          return this.item.numerationType
        },
        function (newValue) {
          this.item.documentsAllowed = []
        }
      )
    },
    getPeriodTypes () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_s_b_period_types', {
          params
        })
        .then(response => {
          this.periodTypes = []
          this.periodTypes = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getInvoiceTypes () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_s_b_invoice_types', {
          params
        })
        .then(response => {
          this.invoiceTypes = []
          let responseData = response.data['hydra:member']
          for (let i in responseData) {
            this.invoiceTypes.push({
              value: responseData[i]['@id'],
              text: responseData[i].name
            })
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getDocumentTypes () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_s_b_document_types', {
          params
        })
        .then(response => {
          this.documentTypes = []
          let responseData = response.data['hydra:member']
          for (let i in responseData) {
            this.documentTypes.push({
              value: responseData[i]['@id'],
              text: responseData[i].name
            })
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
